import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import {
    HTTP_INTERCEPTORS,
    HttpClient,
    provideHttpClient,
    withInterceptors,
    withInterceptorsFromDi,
} from '@angular/common/http';
import {
    InMemoryScrollingOptions,
    provideRouter,
    withComponentInputBinding,
    withInMemoryScrolling,
    withRouterConfig,
} from '@angular/router';
import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { BrowserModule } from '@angular/platform-browser';
import { CustomAura, provideAuth0Module } from '@core/config';
import { provideTranslateModule } from '@core/i18n';
import { globalHttpInterceptorFn } from '@core/interceptors';
import { routes } from './app.routes';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}

const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'top',
};

export const appConfig: ApplicationConfig = {
    providers: [
        MessageService,
        ConfirmationService,
        BrowserModule,
        BrowserAnimationsModule,

        provideZoneChangeDetection({ eventCoalescing: true }),
        provideTranslateModule(),
        provideAnimationsAsync(),
        provideAuth0Module(),

        providePrimeNG({
            theme: {
                preset: CustomAura,
                options: {
                    darkModeSelector: '.dark-mode',
                },
            },
        }),

        provideHttpClient(withInterceptors([globalHttpInterceptorFn]), withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptor,
            multi: true,
        },

        provideRouter(
            routes,
            withInMemoryScrolling(scrollConfig),
            withComponentInputBinding(),
            withRouterConfig({ paramsInheritanceStrategy: 'always' })
        ),
    ],
};
